<div class="job-description-container">
  @if (planLimitReached && !loading) {
    <div class="plan-limit-message" role="alert">
      <i class="pi pi-lock"></i>
      <p>{{ t.ERROR_PLAN_LIMIT }}</p>
      <button type="button" class="plan-limit-cta" (click)="goToPlans()">
        {{ t.ERROR_PLAN_LIMIT_CTA }}
        <i class="pi pi-arrow-right"></i>
      </button>
    </div>
  }

  <!-- One smart input instead of the old "Paste text" / "Paste URL" tabs:
       the same textarea accepts either, and inputKind decides whether
       Submit fetches the link or sends the text as-is. -->
  <app-paste-textarea
    [title]="t.TITLE"
    icon="pi pi-briefcase"
    [placeholder]="t.PLACEHOLDER"
    [value]="jobDescriptionForm.get('jobDescription')?.value || ''"
    [loading]="loading"
    [errorMessage]="errorMessage || urlErrorMessage"
    [submitText]="inputKind === 'url' ? t.SUBMIT_URL : t.SUBMIT"
    [cancelText]="t.CLEAR"
    [showCharacterCount]="inputKind !== 'url'"
    [translations]="pasteTranslations"
    [isInsideWizard]="isInsideWizard"
    (valueChange)="onJobDescriptionChange($event)"
    (onSubmit)="onSubmit()"
    (onCancel)="clearForm()"
    (closeWizardRequest)="closeWizardRequest.emit()"
  >
    <div pasteHint class="input-kind-hint" [attr.data-kind]="inputKind" aria-live="polite">
      @switch (inputKind) {
        @case ('url') {
          <i class="pi pi-link"></i>
          <span>{{ detectedUrlText }}</span>
        }
        @case ('text') {
          <i class="pi pi-file-edit"></i>
          <span>{{ t.DETECTED_TEXT }}</span>
        }
        @default {
          <i class="pi pi-info-circle"></i>
          <span>{{ t.INPUT_HINT }}</span>
        }
      }
    </div>
  </app-paste-textarea>

  <!-- chamba-ai#503: the backend found an application for the same job. -->
  <app-duplicate-application-dialog
    [visible]="duplicateDialogVisible"
    [duplicate]="duplicate"
    mode="create"
    [busy]="duplicateBusy"
    (open)="onDuplicateOpen()"
    (confirm)="onDuplicateConfirm()"
    (cancel)="onDuplicateCancel()"
  ></app-duplicate-application-dialog>
</div>
